var volunteerGroupInfoWindowTemplate, activityInfoWindowTemplate;
var opportunitiesMap;
var markers = [];
var placesIdsNearZip = [];
var searchAreaCircle = null;
var markerClusterer;
var openInfoWindow;

$(function () {
    $('.select2').select2();

    loadOpportunities();
    initHandlebars();
});

function loadOpportunities() {
    $.getJSON('/api/Home/GetOpportunities', function (data) {
        if (data) {
            config.opportunities = data.opportunities;
            $('#interestFilter').empty().select2({ data: data.interests }).val(data.selectedInterestIds).trigger('change');
            $('#placeFilter').empty().select2({ data: data.places }).trigger('change');
            initMap();
            initEvents();
        }
    });
}

function initHandlebars() {
    volunteerGroupInfoWindowTemplate = Handlebars.compile($('#volunteerGroupInfoWindowTemplate').html());
    activityInfoWindowTemplate = Handlebars.compile($('#activityInfoWindowTemplate').html());
}

function initMap() {
    searchAreaCircle = new google.maps.Circle({
        strokeColor: '#C0C0C0',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#C0C0C0",
        fillOpacity: 0.35,
        center: new google.maps.LatLng(config.center),
        radius: 25 * 1609.344 //Miles to meters
    });

    opportunitiesMap = new google.maps.Map(document.getElementById('opportunitiesMap'), {
        center: config.center,
        zoom: config.zoom,
        streetViewControl: false,
        gestureHandling: 'greedy'
    });

    config.opportunities.forEach(function (p) {
        var marker = new google.maps.Marker({
            map: opportunitiesMap,
            position: p.position,
            title: p.title,
            interestIds: p.interests.map(function (x) { return x.interestId }),
            placeId: p.placeId
        });

        var infoWindowContent = null;

        if (p.opportunityType === 'volunteerGroup') {
            infoWindowContent = volunteerGroupInfoWindowTemplate(p)
        }
        else if (p.opportunityType === 'activity') {
            infoWindowContent = activityInfoWindowTemplate(p)
        }

        var infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent
        });

        marker.addListener("click", function () {
            if (openInfoWindow) {
                openInfoWindow.close();
            }
            infoWindow.open(opportunitiesMap, marker);
            openInfoWindow = infoWindow;
        });

        markers.push(marker);
    });

    // Add a marker clusterer to manage the markers.
    markerClusterer = new MarkerClusterer(opportunitiesMap, markers, {
        imagePath: "/lib/marker-clusterer-plus/images/m"
    });

    var minClusterZoom = 15; //(first level without clustering)
    markerClusterer.setMaxZoom(minClusterZoom);

    google.maps.event.addListener(markerClusterer, 'clusterclick', function (cluster) {
        if (opportunitiesMap.getZoom() > minClusterZoom + 1) { // If zoomed in past minClusterZoom, zoom out to minClusterZoom
            opportunitiesMap.setZoom(minClusterZoom + 1);
        }
    });

    // Make overlapping markers spider
    var oms = new OverlappingMarkerSpiderfier(opportunitiesMap, {
        markersWontMove: true,
        keepSpiderfied: true
    });

    markers.forEach(function (m) {
        oms.addMarker(m);
    });

    //Initial zip filter
    if ($('#zipCodeFilter').val()) {
        filterPlacesNearZip();
    }
}

function initEvents() {
    $(document).on('change', '#interestFilter', updateMarkers);
    $(document).on('change', '#placeFilter', updateMarkers);
    $(document).on('input', '#zipCodeFilter', filterPlacesNearZip);
    $(document).on('change', '#radiusFilter', filterPlacesNearZip);

    $(document).on('click', '#clearFiltersBtn', function () {
        searchAreaCircle.setMap(null);
        placesIdsNearZip = [];
        $('#zipCodeFilter').val('');
        $('#radiusFilter').val('25');
        $('#placeFilter').val('').trigger('change');
        $('#interestFilter').val('').trigger('change');
    });

    google.maps.event.addListener(opportunitiesMap, 'click', function () {
        if (openInfoWindow) {
            openInfoWindow.close();
        }
    });
}

function hasZipFilter() {
    var zipCode = $('#zipCodeFilter').val();
    var radius = $('#radiusFilter').val();

    return (radius && zipCode && zipCode.length === 5);
}

function filterPlacesNearZip() {
    var zipCode = $('#zipCodeFilter').val();
    var radius = $('#radiusFilter').val();

    if (hasZipFilter()) {
        postAsJson('/api/Home/GetLatLngByZipCode', JSON.stringify({ zipCode: zipCode }), function (latLng) {
            if (latLng && latLng.lat && latLng.lng) {
                opportunitiesMap.setCenter(latLng);

                var radiusInMeters = Number(radius) * 1609.344; //miles to meters

                searchAreaCircle.setCenter(new google.maps.LatLng(latLng));
                searchAreaCircle.setRadius(radiusInMeters);
                searchAreaCircle.setMap(opportunitiesMap);

                placesIdsNearZip = [];
                markers.forEach(function (x) {
                    var distanceBetweenInMeters = google.maps.geometry.spherical.computeDistanceBetween(x.getPosition(), searchAreaCircle.getCenter());

                    if (distanceBetweenInMeters <= radiusInMeters) {
                        placesIdsNearZip.push(x.placeId);
                    }
                });

                updateMarkers();
            }
            else {
                resetRadiusFilters();
            }
        });
    }
    else {
        resetRadiusFilters();
    }
}

function resetRadiusFilters() {
    placesIdsNearZip = [];
    searchAreaCircle.setMap(null);
}

function updateMarkers() {
    markerClusterer.clearMarkers();
    var interestIds = $('#interestFilter').val();
    var placedIds = $('#placeFilter').val();
    var checkPlaceIds = hasZipFilter();

    markers.forEach(function (x) {
        var includeMarker = true;

        if (interestIds && interestIds.length > 0 && !interestIds.some(function (id) { return x.interestIds.includes(id); })) {
            includeMarker = false;
        }

        if (placedIds && placedIds.length > 0 && !placedIds.some(function (id) { return x.placeId === id; })) {
            includeMarker = false;
        }

        if (checkPlaceIds && !placesIdsNearZip.some(function (id) { return x.placeId === id; })) {
            includeMarker = false;
        }

        if (includeMarker) {
            x.setMap(opportunitiesMap);
            markerClusterer.addMarker(x);
        }
        else {
            x.setMap(null);
            markerClusterer.removeMarker(x);
        }
    });
}